export const CALENDAR_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';
